
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sandbox/studio",
      function () {
        return require("private-next-pages/docs/sandbox/studio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sandbox/studio"])
      });
    }
  